/*
 * @Author: liyxt
 * @Date: 2020-05-28 14:28:27
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 14:36:00
 * @Description: file content
 */ 
import React, { Component } from 'react';
import OriginAffix from 'bee-affix';
require('bee-affix/build/Affix.css');
import "./index.less";

class Affix extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			cls:'',
			//defaultContainer: null,
		 }
	}

	// componentDidMount(){
	// 	let { container } = this.props;
	// 	if(!container){
	// 		//此处加 container是由于 2005及之前版本 滚动条在html affix默认container是body
	// 		// 2012滚动条在body, affix固定效果失效  需要添加target和container属性才有效
	// 		this.setState({
	// 			defaultContainer: document.querySelector('#app')
	// 		})
	// 	}
	// }
	
	/**
	 * 触发固定或者固定取消时的回调函数,返回值obj :{ affixed: true, event: evt}
	 */
	onChange = (obj) => {
		let { onChange } = this.props;
		let { affixed } = obj;
		if(affixed==false){
			this.setState({
				cls:''
			})			  
		}else{
			this.setState({
				cls:'tringer-affixed-bg'
			})
		}
		if(typeof onChange === 'function'){
			onChange(obj);
		}
	}
	render() { 
		//let { cls, target, defaultContainer } = this.state;
		//let { container, ...others } = this.props;
		return <OriginAffix 
					{...this.props} 
					//container = {container? container: defaultContainer}
					zIndex={100} 
					className={this.state.cls ? this.state.cls : ''}
					onChange={this.onChange}
					//target={target? target: ()=>document.body}
				/>;
	}
}
 
export default Affix;
